import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    APIS,
    URLS,
    SF_ALTER_MGR_INFO,
    SG_ALTER_MGR_LIST,
} from "@/tra/tancis/ptli/ewc/svr/services/EwciAlterMgrService";

/*
 * Alert Receiver Management List
 * !== 경고 수신자 관리 목록 ==!
 */
export const EWCI1001007Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();

    const [ origin, setOrigin ] = useState<any[]>([]);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        alterMgrInfo: useForm({
            defaultSchema: SF_ALTER_MGR_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        alterMgrList: useGrid({
            defaultSchema: SG_ALTER_MGR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Get Alert Receiver Management List. !== EWACS 경고 목록 조회.==!
        getAlterMgrList: useFetch({
            api: (data) => {
                return APIS.getAlterMgrList({ data: data });
            },
            enabled: true,
            onSuccess: (data) => {
                console.log(data);
                setOrigin(data.alertRules.content);
            },
        }),
    };

    const handler = {
        quickSearchEvent: () => {

            const title = form.alterMgrInfo.getValue('title') || '';
            const uid = form.alterMgrInfo.getValue('uid') || '';
            const condition = form.alterMgrInfo.getValue('condition') || '';

            const result = origin.filter(data => data.title.includes(title.toLowerCase())
                                                    && data.uid.includes(uid.toLowerCase())
                                                    && data.condition.includes(condition.toUpperCase()));

            grid.alterMgrList.setData(comnUtils.getGridData(result));
        },
    };
    
    const render = {
        grid_alterMgrList: {
            cell: {
                title: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Link
                        to={`${URLS.ewci1001008s}/${rowValues.uid}`}
                        state={{ data: rowValues }}
                        >{`${rowValues.title}`}</Link>
                    );
                },
            },
        },
    };
    
    /*
    * Declaration Page Init Function
    * !== 화면 초기화 함수 선언  ==!
    */
   useEffect(() => {
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.alterMgrInfo.schema.uid}></Group.Control>
                            <Group.Control {...form.alterMgrInfo.schema.title}></Group.Control>
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.alterMgrInfo.schema.condition}></Group.Control>
                            <Group.Control {...form.alterMgrInfo.schema.updated}></Group.Control>
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button role="reset" onClick={() => {}} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.quickSearchEvent();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.alterMgrList.grid}
                            data={fetch.getAlterMgrList.data?.alertRules}
                            render={render.grid_alterMgrList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
